import styled from 'styled-components';

import {commonPalette} from 'styles/palette';
import {darken} from 'utils/color-utils';

export const ViewWrapper = styled.div`
  max-width: 722px;
  width: 100%;
  margin: 0 auto;
`;

export const Section = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: ${({isMobile}) => (isMobile ? 'left' : 'center')};
  ${({isMobile}) => (isMobile ? 'flex-direction: column;' : '')}
`;

export const TextWrapper = styled.div`
  flex: 4;
  margin-bottom: ${({isMobile}) => (isMobile ? '16px;' : '')};
`;

export const SectionTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
`;

export const SectionSubtitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-top: 8px;
`;

export const SectionDelimiter = styled.div`
  border-bottom: 1px solid ${commonPalette.borderGrey};
  margin: 30px 0;
`;

export const StyledLink = styled.a`
  color: inherit;
  font-weigth: 600;
  border-bottom: 1px solid ${commonPalette.txBlack};
  padding-bottom: 1px;

  &:hover {
    color: ${commonPalette.txBlack};
  }
`;

export const StyledButton = styled.a`
  color: ${commonPalette.white};
  background: ${commonPalette.sgGreen};
  padding: 10px;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  flex: 1;

  &:hover {
    color: ${commonPalette.white};
    background: ${darken(commonPalette.sgGreen, 0.15)};
  }

  &:link {
    text-decoration: none;
  }

  ${({isMobile}) => (isMobile ? 'margin: 10px auto 0 0;' : '')}
`;

export const ButtonWrapper = styled.div`
  width: 135px;
  display: flex;
  ${({isMobile}) => (isMobile ? '' : 'margin-left: 40px;')}
  flex: 1;
`;
